import * as echarts from 'echarts';

export interface DataZoomRange {
  start?: number;
  end?: number;
  startValue?: number | string;
  endValue?: number | string;
}

// Utility function to create dataZoom configuration
export const createDataZoomConfig = (
  isDark: boolean,
  axisColor: string,
  range?: DataZoomRange,
): echarts.DataZoomComponentOption[] => {
  return [
    {
      type: 'slider',
      show: true,
      xAxisIndex: [0],
      bottom: '3%',
      height: 18,
      borderColor: 'transparent',
      backgroundColor: isDark ? 'rgba(55, 65, 81, 0.3)' : 'rgba(243, 244, 246, 0.8)',
      fillerColor: isDark ? 'rgba(236, 72, 153, 0.3)' : 'rgba(236, 72, 153, 0.2)',
      textStyle: {
        color: axisColor,
        fontSize: 9,
      },
      handleStyle: {
        color: '#EC4899', // Jua pink
        borderColor: '#EC4899', // Jua pink
        borderWidth: 2,
      },
      moveHandleStyle: {
        color: isDark ? '#6B7280' : '#9CA3AF',
      },
      selectedDataBackground: {
        lineStyle: {
          color: 'transparent',
        },
        areaStyle: {
          color: 'transparent',
        },
      },
      dataBackground: {
        lineStyle: {
          color: 'transparent',
        },
        areaStyle: {
          color: 'transparent',
        },
      },
      start: range?.start ?? 0,
      end: range?.end ?? 100,
      ...(range?.startValue !== undefined ? { startValue: range.startValue } : {}),
      ...(range?.endValue !== undefined ? { endValue: range.endValue } : {}),
      filterMode: 'none',
      throttle: 100,
      realtime: true,
    },
    {
      type: 'inside',
      xAxisIndex: [0],
      zoomOnMouseWheel: true,
      moveOnMouseMove: true,
      filterMode: 'none',
      throttle: 50,
    },
  ];
};
